export const getProcessinguuid = () => {
  const processingUuid = window.localStorage.getItem('processing_uuid')
  return processingUuid || ''
}

export const getFingerprint = () => {
  const fingerprint = JSON.parse(window.localStorage.getItem('fingerprint'))
  return fingerprint?.visitorId ?? ''
}
